export const isFriend = (entityType: string, isContact: number | undefined | boolean): boolean => {
  return !isContact && entityType !== null && entityType === 'friend';
};
